import React from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { CTAContainer, ContentContainer, ContentTitle, EndingPhrase, ImageContainer, SubTitle, SuccessContainer, SuccessImage, Title, TitleContainer } from "./SuccessPriority.styles";
import Logo from '../../../../../public/images/logo-new.svg';
import { Button, List } from "../../../../components";
import { ListArray } from "./SuccessPriority.content";
import Image from "next/image";

interface SuccessProps extends WithRouterProps {
  firstName: string | undefined;
  bookingInterestId: number | undefined | null;
  accessibilityPending?: boolean;
}

const Success: React.FC<SuccessProps> = ({
  firstName,
  bookingInterestId,
  accessibilityPending,
}) => {
  const router = useRouter();

  return (
    <SuccessContainer
      data-cy="booking-interest-registration-success"
      data-bookinginterest-id={bookingInterestId}>
      <TitleContainer>
        <SuccessImage>
        <Image fill src={accessibilityPending ? "/images/email/gifs/flock-happy.gif" : "/images/email/gifs/flock-sad.gif"} alt="TTT Bird Animation" />
        </SuccessImage>
        <Title>
        {accessibilityPending
          ? "We’ve received your priority ticket request!"
          : "😨 Oh No! Priority tickets ran out as you were applying..!"}
        </Title>
        <SubTitle>
        {accessibilityPending
          ? "Due to your accessibility requirements, we need to check if we can accommodate you properly. We’ll get back to you as soon as possible!"
          : "We’re so sorry 🙏. This can happen when demand is really high, they go like hotcakes on a first-come, first-served basis!"}
        </SubTitle>
      </TitleContainer>
      <ContentContainer>
        <ContentTitle>
        {accessibilityPending ? "What happens next?" : "But Don’t Worry!"}
        </ContentTitle>
        <SubTitle>
        {accessibilityPending
          ? "We’re reviewing your request and will be in touch shortly. In the meantime:"
          : "We’ve registered you for a regular ticket instead. See what happens now below:"}
        </SubTitle>
        <ImageContainer>
          <Image src="/images/email/progress-red-carpet-application.png" fill alt="Progress bar - applied for tickets step" />
        </ImageContainer>
        <List elements={ListArray} />
      </ContentContainer>
      <CTAContainer>
        <EndingPhrase>
          Want to increase your chances of getting tickets?
        </EndingPhrase>
        <Button onClick={() => router.reload()} data-cy="book-another-ticket-button"> Apply for another Session </Button>
      </CTAContainer>
    </SuccessContainer>
  );
};

export default withRouter(Success);
